/// <reference path="../_references.ts"/>

module App.History {


	import DispatchCode = App.Customer.DispatchCode;
	import ServiceRequestType = App.Appointments.ServiceRequestType;
	import PaymentType = App.Payment.PaymentType;
	import LeadSource = App.Appointments.LeadSource;
	import Salesman = App.Appointments.Salesman;
	import ServicePlan = App.Appointments.ServicePlan;
	import FinancePlan = App.Appointments.FinancePlan;
	import ServiceNote = App.Appointments.ServiceNote;
	import Appointment = App.Customer.Appointment;
	import Package = App.WorkOrderTemplate.Package;
	import Customer = App.Customer.Customer;
	import Department = App.Appointments.Department;
	import Note = App.Administrative.Note;
	import Address = App.Customer.Address;
	import ServiceableItem = App.ItemManagement.ServiceableItem;
	export type HistoryItem = {
		displayName: string;
		sref: string;
		srefAddress: string;
		permission: string;
	}

	export class ServiceRequest {
		id: number;
		service_address: number;
		service_request_type: ServiceRequestType;
		service_request_status: number;
		promised_date: string;
		promised_time: string;
		payment_type: PaymentType;
		lead_source: LeadSource;
		salesman: Salesman;
		service_plan: ServicePlan;
		finance_plan: FinancePlan;
		notes: ServiceNote;
		appointments: Appointment[];
		dispatch_code: DispatchCode;
		department: number;
		technician: number;
		packages: Package[];
		customer: Customer;
		amount_due: string;
		total: number;
		after_hours: boolean;

		constructor() {

		}
	}

	export type ServiceRequestPhoto = {
		id: number;
		caption: string;
		source: string;
	}

	export type ServiceRequestHistoryItem = {
		id: number;
		full_name: string;
		service_date: string;
		invoice_total: number;
		dispatch_code: string;

	}


	type Approval = {
		id: number;
		created: string;
		print_name: string
	}

	type Status = {
		id: number;
		created: string;
		updated: string;
		name: string
	}

	export type Invoice = {
		approved_date: string;
		balance_due: number;
		billing_address: Address;
		company_name: string;
		created: string;
		customer: string;
		discount_amount: number;
		discount_code: string;
		due_date: string;
		finance_plan: number;
		id: number;
		invoice_number: number;
		invoice_organization: any;
		note: string;
		packages: Package[];
		paid_full: boolean;
		service_address: Address;
		service_plan: ServicePlan;
		service_request: number;
		serviceable_items: ServiceableItem[];
		signature: string;
		status: Status;
		subtotal: number;
		tax: number;
		terms: string[];
		total: number;
		total_payments: number;
		total_recurring: number;
		total_savings: number;
		updated: string;
		void_date: string;
		void_reason: string
	}
	/*export type Invoice = {
		after_hours: boolean;
		appointments: Appointment[];
		approval: Approval;
		coupon?: any;
		customer: Customer;
		department: Department;
		description: string;
		dispatch_code: DispatchCode;
		finance_plan: FinancePlan;
		images?: ServiceRequestPhoto[];
		inventories: any[];
		latest_invoice_id: number;
		lead_source: LeadSource;
		location: Location;
		notes: Note[];
		packages: Package[];
		payment_type: PaymentType;
		promised_date: string;
		promised_time: string;
		sales_person: number;
		sales_tax_override_labor: any;
		sales_tax_override_material: any;
		service_address: Address;
		service_plan: ServicePlan;
		service_request_status: string;
		service_request_type: ServiceRequestType;
		serviceable_items: ServiceableItem[];
	}
*/
}